<template>
  <div>
    <v-app-bar color="primary" dark app>
      <v-btn icon @click="$_aoClicarVoltar" title="Voltar para a listagem">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>
        Cadastro Manutenção Frota
      </v-toolbar-title>
    </v-app-bar>

    <!-- Dialog Confirmar Saída -->
    <v-dialog v-model="dialogConfirmarSair" max-width="420" persistent>
      <v-card rounded="lg">
        <v-card-title class="py-3 px-4 primary d-flex align-center">
          <v-icon color="white" class="mr-2">mdi-alert-outline</v-icon>
          <span class="text-subtitle-1 font-weight-bold white--text">
            Confirmar Saída
          </span>
        </v-card-title>

        <v-card-text class="pt-4 pb-2 text-body-1 grey--text text--darken-3">
          Deseja realmente sair? As alterações não salvas serão descartadas.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-3 d-flex justify-end">
          <v-btn
            text
            color="grey darken-1"
            class="text-none font-weight-medium mr-2"
            @click="dialogConfirmarSair = false"
          >
            Não
          </v-btn>
          <v-btn
            color="primary darken-1"
            dark
            depressed
            class="text-none font-weight-bold px-4"
            @click="$_confirmarSair"
          >
            Sim, sair
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ROUTE_MANUTENCAO_FROTA } from '@/constants/ROUTES';
import { ROTA_STORAGE, MANUTENCAO_STORAGE } from '@/constants/STORAGE';

export default {
  name: 'ViewManutencaoCadastroAppBar',

  data() {
    return {
      dialogConfirmarSair: false,
    };
  },

  methods: {
    // Verifica se houve alguma alteração em relação ao snapshot salvo ou inicial
    $_temAlteracoes() {
      try {
        const snapshotStr = sessionStorage.getItem('MANUTENCAO_SNAPSHOT');
        const formStr = sessionStorage.getItem(MANUTENCAO_STORAGE.formulario);

        if (!snapshotStr) {
          if (!formStr) return false;
          const form = JSON.parse(formStr);
          return Boolean(
            form.frota
            || form.operador
            || form.executor
            || form.odometro
            || form.observacao
            || form.evento
            || form.propriedade
            || form.atividade
            || form.garantia
            || (form.itens && form.itens.length > 0),
          );
        }

        if (formStr && formStr !== snapshotStr) {
          return true;
        }

        const garantiaAtual = sessionStorage.getItem('MANUTENCAO_GARANTIA_DIGITADA') || '';
        const garantiaSnapshot = sessionStorage.getItem('MANUTENCAO_SNAPSHOT_GARANTIA') || '';
        if (garantiaAtual !== garantiaSnapshot) {
          return true;
        }

        return false;
      } catch (e) {
        return false;
      }
    },

    $_aoClicarVoltar() {
      if (!this.$_temAlteracoes()) {
        this.$_confirmarSair();
        return;
      }
      this.dialogConfirmarSair = true;
    },

    $_confirmarSair() {
      this.dialogConfirmarSair = false;
      this.$_limparStorageManutencao();
      sessionStorage.removeItem(ROTA_STORAGE.cadastro);
      if (this.$route.name !== ROUTE_MANUTENCAO_FROTA.name) {
        this.$router.replace({
          name: ROUTE_MANUTENCAO_FROTA.name,
        }).catch((err) => {
          if (err && err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },

    $_limparStorageManutencao() {
      sessionStorage.removeItem(MANUTENCAO_STORAGE.formulario);
      sessionStorage.removeItem(MANUTENCAO_STORAGE.campoSelecao);
      sessionStorage.removeItem(MANUTENCAO_STORAGE.itemSelecionado);
      sessionStorage.removeItem('MANUTENCAO_NOVO_ITEM');
      sessionStorage.removeItem('MANUTENCAO_ITEM_EDITANDO_INDEX');
      sessionStorage.removeItem('MANUTENCAO_DIALOG_ITEM_ABERTO');
      sessionStorage.removeItem('MANUTENCAO_SNAPSHOT');
      sessionStorage.removeItem('MANUTENCAO_SNAPSHOT_GARANTIA');
      sessionStorage.removeItem('MANUTENCAO_GARANTIA_DIGITADA');
    },
  },

  created() {
    sessionStorage.setItem(ROTA_STORAGE.cadastro, 'manutencao');
  },
};
</script>
